/** Download-arrow glyph used by the share tiles and the quiz results screen. */
export default function DownloadIcon({ size = 16 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
      <path
        fill="currentColor"
        d="M11 3v10.59L7.71 10.3l-1.42 1.4L12 17.41l5.71-5.71l-1.42-1.4L13 13.59V3h-2zM5 19v2h14v-2H5z"
      />
    </svg>
  );
}
